export const SET_INITIAL_DATA = 'SET_INITIAL_DATA';
export const SET_CURRENT_COMPARED_CATEGORY = 'SET_CURRENT_COMPARED_CATEGORY';
